/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Debug_Logging_LabelInputs */

const en_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debug Logging`)
};

const fr_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal de debogage`)
};

const de_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debug-Protokollierung`)
};

const it_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione di debug`)
};

const ru_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ведение отладочного журнала`)
};

const es_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de depuración`)
};

const zh_cn2_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调试日志`)
};

const ja_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバッグログ`)
};

const hi_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉगिंग डीबग करें`)
};

const pt_pt2_drastic_tech_debug_logging_label = /** @type {(inputs: Drastic_Tech_Debug_Logging_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de depuração`)
};

/**
* | output |
* | --- |
* | "Debug Logging" |
*
* @param {Drastic_Tech_Debug_Logging_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_debug_logging_label = /** @type {((inputs?: Drastic_Tech_Debug_Logging_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Debug_Logging_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_debug_logging_label(inputs)
	if (locale === "de") return de_drastic_tech_debug_logging_label(inputs)
	if (locale === "it") return it_drastic_tech_debug_logging_label(inputs)
	if (locale === "ru") return ru_drastic_tech_debug_logging_label(inputs)
	if (locale === "es") return es_drastic_tech_debug_logging_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_debug_logging_label(inputs)
	if (locale === "ja") return ja_drastic_tech_debug_logging_label(inputs)
	if (locale === "hi") return hi_drastic_tech_debug_logging_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_debug_logging_label(inputs)
	return en_drastic_tech_debug_logging_label(inputs)
});